import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { Modal, Button } from 'antd';

import { isRegionalSupplyHeadRole, isSupplyRole, isAdminRole } from '~helpers/auth';
import { updateHomepageSetting } from '../../gql';

import SettingTable from './settingTable';

function ModuleSettingModal({ t, onClose, visible, refetch, citySlug, data }) {
  const originDataRef = useRef();
  const [tempData, setTempData] = useState();
  const [mutationHomepageSetting, { loading }] = useMutation(updateHomepageSetting, {
    onCompleted: () => {
      refetch();
      onClose();
    },
  });

  const handleConfirmClick = () => {
    const formatData = tempData.map((data, index) => ({
      [data.name]: {
        enabled: data.enabled,
        position: index,
      },
    }));
    mutationHomepageSetting({
      variables: { input: { citySlug, desktopSetting: Object.assign({}, ...formatData) } },
    });
  };

  useEffect(() => {
    originDataRef.current = data;
    setTempData(data);
  }, [data]);

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      width={812}
      wrapClassName="module-setting-modal"
      footer={null}
      centered
      confirmLoading={loading}
      maskClosable={false}
    >
      <div className="module-setting-modal__content">
        <h3 className="module-setting-modal__title">
          {t('cms.dashboard.strategy.module_setting.title')}
        </h3>
        <div className="subtitle">{t('cms.dashboard.strategy.module_setting.subtitle')}</div>
        <SettingTable data={tempData} setData={setTempData} t={t} />
      </div>
      <div className="footer-bottom">
        <Button onClick={() => onClose()} className="cancel-btn">
          {t('cms:cms.tag_modal.header.btn.cancel')}
        </Button>
        <If condition={isAdminRole() || isSupplyRole() || isRegionalSupplyHeadRole()}>
          <Button type="primary" onClick={handleConfirmClick} className="confirm-btn">
            {t('cms:cms.tag_modal.header.btn.confirm')}
          </Button>
        </If>
      </div>
    </Modal>
  );
}

ModuleSettingModal.propTypes = {
  t: PropTypes.func,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
  refetch: PropTypes.func,
};

ModuleSettingModal.defaultProps = {
  t: () => {},
  onClose: () => {},
  visible: false,
  refetch: () => {},
};

export default ModuleSettingModal;
